<template>
  <div>
    <avue-crud
      ref="crud"
      v-model="form"
      :option="option"
      :table-loading="loading"
      :data="data"
      :page.sync="page"
      :search.sync="query"
      :defaults.sync="defaults"
      @row-save="rowSave"
      @row-update="rowUpdate"
      @row-del="rowDel"
      @search-change="searchChange"
      @search-reset="searchReset"
      @refresh-change="refreshChange"
      :beforeOpen="beforeOpen"
      @current-change="currentChange"
      @size-change="sizeChange"
      @on-load="onLoad"
      @selection-change="selectionChange"
    >
      <template slot="menuLeft">
        <el-button
          type="danger"
          size="small"
          icon="el-icon-delete"
          plain
          :disabled="selectionList.length === 0"
          @click="handleDelete"
        >批量删除</el-button>
      </template>
    </avue-crud>
  </div>
</template>

<script>
import crudMixins from "@/mixins/crud-mixins";
import { getList, add, update, remove, getDetail, removeBatch } from "./api";
import { getSearchTimeConfig, rulesInput } from "@/basic-common/util/common";

export default {
  mixins: [crudMixins],
  data () {
    return {
      form: {},
      apiConfig: { getList, add, update, remove, getDetail, batchRemove: removeBatch },
      option: {
        ...this.$store.state.publicOption,
        searchDateProp: false,
        selection: true,
        column: [
          {
            label: '人员类型',
            prop: 'personType',
            type: 'select',
            search: true,
            dicData: [
              { label: '负责人', value: 1 },
              { label: '成员', value: 2 },
            ],
            value: 2,
            rules: rulesInput(2),
          },
          {
            label: '姓名',
            prop: 'name',
            search: true,
            overHidden: true,
            maxlength: 64,
            rules: rulesInput(1),
          },
          {
            label: '联系电话',
            prop: 'phone',
            search: true,
            overHidden: true,
            maxlength: 32,
            rules: [
              { required: true, message: '请输入联系电话', trigger: 'blur' },
              { pattern: /^1[3-9]\d{9}$/, message: '请输入正确的手机号码', trigger: 'blur' }
            ],
          },
          {
            label: '岗位',
            prop: 'roleCode',
            search: true,
            overHidden: true,
            type: 'select',
            dicUrl: '/api/blade-system/dict-biz/dictionary?code=emergency_support_role',
            props: { label: 'dictValue', value: 'dictKey' },
            rules: rulesInput(2),
          },
          {
            label: '职责描述',
            prop: 'dutyDesc',
            type: 'textarea',
            span: 24,
            minRows: 2,
            maxlength: 512,
            overHidden: true,
            rules: rulesInput(2),
          },
          {
            label: '头像地址',
            prop: 'avatarUrl',
            overHidden: true,
            hide: true,
          },
          {
            label: '排序',
            prop: 'sortOrder',
            type: 'number',
            min: 0,
            precision: 0,
            value: 0,
            width: 100,
            rules: rulesInput(2),
          },
          {
            label: '状态',
            prop: 'status',
            type: 'select',
            search: true,
            width: 100,
            dicData: [
              { label: '停用', value: 0 },
              { label: '启用', value: 1 },
            ],
            value: 1,
            rules: rulesInput(2),
          },
          {
            label: '备注',
            prop: 'remark',
            type: 'textarea',
            hide: true,
            span: 24,
            minRows: 2,
            maxlength: 512,
          },
          {
            label: '录入人',
            prop: 'createName',
            hide: true,
            addDisplay: false,
            editDisplay: false,
          },
          {
            label: '录入时间',
            prop: 'createTime',
            type: 'datetime',
            format: 'yyyy-MM-dd HH:mm:ss',
            valueFormat: 'yyyy-MM-dd HH:mm:ss',
            overHidden: true,
            width: 180,
            addDisplay: false,
            editDisplay: false,
          },
          {
            ...getSearchTimeConfig('', { type: 'datetimerange' }),
            searchValue: [],
            paramsKey: ["startTime", "endTime"],
          },
          {
            label: '修改人',
            prop: 'updateName',
            hide: true,
            addDisplay: false,
            editDisplay: false,
          },
          {
            label: '修改时间',
            prop: 'updateTime',
            type: 'datetime',
            format: 'yyyy-MM-dd HH:mm:ss',
            valueFormat: 'yyyy-MM-dd HH:mm:ss',
            overHidden: true,
            width: 180,
            addDisplay: false,
            editDisplay: false,
            hide: true,
          },
        ],
      },
      defaultParams: {},
    };
  },
};
</script>
